var _circle, _g, _path, _path2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#fcfcfc",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a2001d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m105.739 237.449-27.826-50.483 27.826-49.691 27.826 49.691z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.087 237.449-27.826-50.483 27.826-49.691 27.826 49.691z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.739 374.725-27.826-50.483 27.826-49.691 27.826 49.691z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.087 374.725-27.826-50.483 27.826-49.691 27.826 49.691z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.565 49.692-7.878-14.068c-14.13 8.372-27.383 18.065-39.594 28.909l19.646 35.641z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.739 411.826-19.854 35.456c12.2 10.858 25.444 20.566 39.568 28.955l8.113-14.719z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m155.826 322.783v168.863c30.769 13.097 64.622 20.354 100.174 20.354 110.071 0 203.906-69.472 240.077-166.957z",
    fill: "#6da544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m496.077 345.043c10.291-27.733 15.923-57.729 15.923-89.043 0-141.384-114.616-256-256-256-35.549 0-69.405 7.253-100.174 20.348v324.696h340.251z",
    fill: "#a2001d"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBy);
export default __webpack_public_path__ + "static/media/4bd96339571d74328867a4c45f0687d1dacb7cf1d8.svg";
export { ForwardRef as ReactComponent };